module.exports = __webpack_public_path__ + "static/media/icon_footer_linkedin.63649c53.svg";